import { Field } from 'formik';
import React from 'react';
import { MiniAppFocusWrapper } from 'src/components';
import { InputField } from 'src/features/common';
import { useIsMobile } from 'src/features/common/hooks/use-is-mobile';
import { AddressModalPageProps } from 'src/features/dpo/components/delivery-address-modal-v2/delivery-address-modal';
import { BOUNDS } from 'src/features/onboarding/pages/business-details/resources/bounds';
import { idMask, phoneNumberMaskSpaced } from 'src/helpers/formatting';

export function ReceiverDetailsStep(props: AddressModalPageProps) {
  React.useEffect(() => {
    props.validateForm && props.validateForm();
  }, []);

  return (
    <article className="flex flex-col md:w-112">
      <h1 className="text-2xl font-medium text-center text-gray-700 md:text-4xl py-7">
        Who will be receiving the delivery?
      </h1>
      <section className="flex-1 overflow-y-auto">
        <div className="overflow-y-auto space-y-3 h-full pr-[5px] pl-[5px]">
          <Field
            name="receiverDetails.managerName"
            type="text"
            placeholder="Recipient full name"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
            fieldType="standard"
            className="top-field light"
            autoFocus={!useIsMobile()}
          />
          <Field
            name="receiverDetails.idNumber"
            type="tel"
            placeholder="Recipient ID number"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
            mask={idMask}
            guide={true}
            fieldType="masked"
            className="light"
          />
          <Field
            mask={phoneNumberMaskSpaced}
            id="phone_cell"
            name="receiverDetails.cellPhone"
            placeholder="Recipient cell number"
            className="light"
            type="tel"
            guide={true}
            fieldType="masked"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
          />
          <Field
            mask={phoneNumberMaskSpaced}
            id="phone_work"
            name="receiverDetails.workPhone"
            placeholder="Recipient work number"
            className="light"
            type="tel"
            guide={true}
            fieldType="masked"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
          />
          <Field
            name="receiverDetails.tradingAs"
            type="text"
            placeholder="Trading name"
            component={MiniAppFocusWrapper}
            maxLength={BOUNDS.NAME_LENGTH}
            innerComponent={InputField}
            fieldType="standard"
            className="bottom-field light"
          />
        </div>
      </section>
    </article>
  );
}
